export default __webpack_public_path__ + "static/center-en-7c1dd57bee2df527c35211b9d7c89d02.webp";